export default __webpack_public_path__ + "static/media/logo.abdfe3ff.png";